import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c6ccd92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "items-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pad-title" }, " 제안 가격 ", -1))
const _hoisted_5 = { class: "pad-price" }
const _hoisted_6 = { class: "strong" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_8 = { class: "pad-total" }
const _hoisted_9 = { class: "gray_text" }
const _hoisted_10 = { class: "deal-center" }
const _hoisted_11 = { class: "pad-container" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "00", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/Delete@3x.png",
  class: "Delete",
  alt: "backspace"
}, null, -1))
const _hoisted_17 = { class: "space-between" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 취소 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 제안 전송 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.currency(_ctx.reValue.price)), 1),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, "직전 제안 조건 " + _toDisplayString(_ctx.$filters.currency(_ctx.reValue.sellPrice)) + " 원", 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (row) => {
          return _createElementVNode("div", {
            key: row,
            class: "row"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (col) => {
              return _createElementVNode("div", {
                key: col,
                class: "ion-activatable ripple-parent letter",
                onClick: ($event: any) => (_ctx.addNumber(row * 3 + col))
              }, [
                _createElementVNode("span", null, _toDisplayString(row * 3 + col), 1),
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 8, _hoisted_12)
            }), 64))
          ])
        }), 64)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent letter",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNumber('00')))
          }, [
            _hoisted_14,
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ]),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent letter",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNumber(0)))
          }, [
            _hoisted_15,
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ]),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent letter",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearNumber('del')))
          }, [
            _hoisted_16,
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: "ion-activatable ripple-parent left_btn btn_groups",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
      }, [
        _hoisted_18,
        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
      ]),
      _createElementVNode("button", {
        class: "ion-activatable ripple-parent right_btn btn_groups",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendRequest && _ctx.sendRequest(...args)))
      }, [
        _hoisted_19,
        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
      ])
    ])
  ]))
}